{
   "actions": {
      "add": "Add | Add {name} | {name} added",
      "add-type": "add {type}",
      "download": "Download",
      "view": "View",
      "apply": "Apply",
      "bug-report": "Report bug",
      "cancel": "Cancel | Cancel",
      "change": "Modify | Modify {name}",
      "change-type": "adjust {type}",
      "clear": "Empty",
      "clear-direct-search": "Clear direct search",
      "click-here": "Click here",
      "close": "Close",
      "confirm": "Confirm",
      "copy": "Copy",
      "create": "create {item}",
      "delete": "Delete | Delete",
      "delete-hard": "Hard delete",
      "export": "Export | Export {type}",
      "manage-organisation": "Manage my organization",
      "no-batches": "No running processes",
      "notifications": "Notifications",
      "notion-page": "Manual",
      "refresh": "Reload page",
      "remove": "Clear | Clear all",
      "remove-styling": "Remove styling",
      "reset": "Reset",
      "reset-filters": "Reset filters",
      "running-batches": "1 ongoing process | \n{amount} running processes",
      "save": "Save",
      "search": "Search | Search",
      "select": "Select",
      "send": "Send",
      "send-request": "Send request",
      "settings": "Settings",
      "show-more": "Show more",
      "upload": "Upload | Upload {type}",
      "print": "Print",
      "validate": "Validate",
      "select-all": "Select all",
      "retry": "Try again",
      "save-and-continue": "Save and next",
      "edit": "Edit | {name} edited"
   },
   "app-name": "NxtMatch",
   "running-processes": {
      "title": "Running processes",
      "subtitle": "Work that still needs your attention",
      "tabs": {
         "running": "Running",
         "completed": "Completed",
         "failed": "Failed"
      },
      "bulk-cv-import": "Bulk CV import",
      "batch-title": "CV batch {date}",
      "batch-title-with-list": "CV batch {date} – {name}",
      "uploaded": "{done} of {total} CVs uploaded",
      "reviewed": "{done} of {total} CVs reviewed",
      "duplicates": "{done} of {total} CVs validated for duplicates",
      "continue": "Continue",
      "cancel": "Cancel",
      "empty-running": "No running processes",
      "empty-completed": "No completed processes",
      "empty-failed": "No failed processes",
      "just-now": "Just now",
      "minutes-ago": "{count} min ago",
      "hours-ago": "{count} h ago",
      "days-ago": "{count} d ago"
   },
   "ai-matching": {
      "ai-matching": "AI Matching",
      "landing-title": "Find the best talent with AI.",
      "landing-subtitle": "Select a vacancy and AI automatically analyzes your talent pool. You get a ranked list with an explanation of why each talent matches.",
      "recommended": "Recommended",
      "priority-high": "High priority",
      "feature-smart-match-title": "Smart matching",
      "feature-smart-match-description": "Criteria are extracted automatically from the vacancy text.",
      "feature-explanation-title": "Explanation per match",
      "feature-explanation-description": "AI explains why someone is or is not a fit.",
      "feature-learns-title": "Learns from you",
      "feature-learns-description": "The more you shortlist, the better the suggestions become.",
      "start-first-matching": "Start your first matching",
      "start-matching": "Start matching",
      "ready-to-match": "Vacancies ready to match",
      "analyse-title": "AI Match Analysis",
      "give-feedback": "Give feedback",
      "feedback-title": "Give feedback",
      "feedback-question": "Was this AI analysis correct?",
      "feedback-saved": "Feedback saved",
      "feedback-suggestion-skills": "Skills are correct",
      "feedback-suggestion-experience": "Good experience",
      "feedback-suggestion-location": "Location ok",
      "new-matching": "+ New matching",
      "active-matchings": "Active matchings",
      "active-matchings-subtitle": "Click on a vacancy to view the found talents.",
      "select-a-matching": "<< Select a matching",
      "found-talents": "Found talents",
      "counts": "{liked} shortlist · {disliked} not retained",
      "all-talents": "All talents ({count})",
      "shortlist": "Shortlist ({count})",
      "not-selected": "Not selected ({count})",
      "matching-in-progress": "AI matching is in progress...",
      "select-a-candidate": "Select a candidate",
      "no-preference": "No preference",
      "search-radius-from": "Search radius from {city}",
      "keywords": "Keywords",
      "keywords-placeholder": "E.g. sales assistant, seller",
      "keywords-label": "Add specific skills, technologies or experience",
      "delete-matching": "Delete matching",
      "delete-matching-description": "Are you sure you want to delete this matching? This action cannot be undone.",
      "matching-done": "AI matching is done. The candidates are available."
   },
   "call-lists": {
      "added-to-call-list": "{amount} candidate added to call list | {amount} candidates added to the call list",
      "auto-calling": "Auto call",
      "call-list": "Call lists",
      "call-list-deleted": "Call list has been deleted",
      "candidate-skipped": "Candidate {first_name} {last_name} was skipped because (s)he does not wish to be contacted by phone.",
      "candidate-skipped-called": "Candidate {first_name} {last_name} was skipped because it has already been contacted.",
      "candidates": {
         "delete-candidates": "Remove candidates from call list?",
         "delete-candidates-description": "Delete these candidates. This action cannot be undone, are you sure?",
         "delete-candidates-from-list": "Remove candidates from call list",
         "set-handled": "Mark as treated",
         "set-unhandled": "Mark as not treated"
      },
      "delete-call-list": "Delete call list?",
      "delete-call-list-description": "Delete the call list {call_list}. This action cannot be undone, are you sure?",
      "failed-lookups": "{amount} values couldn't be found.",
      "import-candidates-call-list": "Import candidates in call list",
      "my-call-lists": "My call lists",
      "no-candidates-added-to-call-list": "Aucun candidat n'a été ajouté à une liste d'appel!",
      "no-new-candidates-added-to-call-list": "No new candidates added to call list",
      "put-in-values": "Enter values (seperated by 'enter')",
      "saved-call-list": "Saved call lists",
      "zoiper-message": "Don't forget to enable the option 'Enable incoming call handling' in Zoiper's settings and turn it off after calling."
   },
   "candidates": {
      "view-candidate": "View candidate",
      "able-bodied-person": "Able bodied person",
      "account-number": "Account number",
      "activated-message": "The candidate activated his account and now manages his personal data himself. \nIf any data is missing, use the <span style=\"color: var(--nxt-main)\"><i class=\"fa-solid fa-paper-plane\"></i> Verify</span> buttons \nwith the missing data so that the candidate can supplement the missing data.",
      "activated-title": "Candidate manages his own data",
      "add-candidate": "Add candidate",
      "add-candidate-to-pool": "Add candidate to pool | Add candidates to pool",
      "add-to-pool": "Add to NxtPlan pool",
      "added-to-pool": "Added to the NxtPlan pool | {amount} {name} added to the NxtPlan pool",
      "approval-history": "Approval history",
      "approval-state": "Approval status",
      "ask-for-approval-success": "Approval request has been sent",
      "bic-number": "BIC-number",
      "birth-date": "Date of birth",
      "board": "Board",
      "bulk-parse-cv": "Bulk parsing CVs",
      "bulk-parse-resume": "Parse resumes in bulk",
      "candidate": "Candidate | Candidates",
      "candidate-created": "Candidate has been added",
      "candidate-in-running-selected-customers": "The candidate is already in the running for one of the selected customers",
      "candidate-poked": "The candidate was poked",
      "candidate-updated": "Candidate has changed",
      "certificates": "Certificate | Certificates",
      "citizen-service-number": "Citizen service number",
      "click-to-go-to-candidate": "Click here to view the candidate",
      "communication-preferences": "How do you wish to receive communication regarding {type}?",
      "competences": "Competence | \nCompetences",
      "contract-type": "Contract type",
      "courses": "Course | Courses",
      "current-data": "Current data",
      "curriculum-vitae": "Curriculum Vitae | \nCV",
      "define-candidate-and-cv": "Define candidate and CV",
      "define-candidate-and-resume": "Define candidate and resume",
      "degree": "Degree | \nDegrees",
      "degree-level": "Educational attainment",
      "delete-candidates": "Delete candidate | Delete candidates",
      "delete-note": "Delete note",
      "delete-note-description": "Are you sure you want to delete this note?",
      "delete-resume": "Delete resume",
      "dependant": "Dependants",
      "desired-function": "Desired functions",
      "disabled-person": "Disabled person",
      "download-file": "Download file",
      "download-resume": "Download resume",
      "drivers-license": "Drivers license",
      "edit-candidate": "Edit candidate",
      "educations": "Studies",
      "email": "E-mail address",
      "experience": "Experience | \nExperiences",
      "export-limit-exceeded": "Not possible to export more than {amount} results",
      "exporting-candidates": "Exporting candidates",
      "first-name": "First name",
      "found-existing-candidate-with-social-security-number": "An existing candidate has been found using this social security number.",
      "free-edit-text": "Mail to candidate",
      "free-text-mail": "Free text",
      "frontier-worker-certificate": "Frontier worker certificate",
      "internal-employee": "Internal employee",
      "invalid-bsn-number": "Citizen service number is invalid",
      "invalid-emails": "{amount} candidate(s) do not have an email and were not added!",
      "invalid-french-SSN": "National register number is invalid!",
      "job-content": "Job content",
      "job-function": "Function",
      "job-preferences": "Job preferences",
      "journey": "Journey",
      "journey-to-candidate": "Mail Journey to candidate",
      "journeys": "Journeys",
      "journey-dropdown-info-text": "Journeys with status \"ongoing\" are available to send.",
      "language-knowledge": "Language knowledge | \nLanguage knowledge",
      "language-knowlegde": "Language knowledge",
      "last-active": "Last active",
      "last-contact": "Last contact",
      "last-name": "Name",
      "mail-candidates": "Email candidate | \nEmail candidates",
      "mail-to-team": "Introducing to team",
      "major": "Study field",
      "marital-status": "Marital status",
      "max-amount-candidates": "Maximum {amount} candidate | Maximum {amount} candidates",
      "national-registration-number": "Social security number",
      "nationality": "Nationality",
      "no-activities": "No activities found",
      "no-approval-state": "No approval status",
      "no-email": "{name} does not have an email address",
      "no-email-contact-allowed": "Candidate does not wish to be contacted by email",
      "no-journeys": "No journeys found",
      "no-phone-contact-allowed": "Candidate does not wish to be contacted by phone",
      "no-sms-contact-allowed": "Candidate does not wish to be contacted by SMS",
      "no-whatsapp-contact-allowed": "Candidate does not wish to be contacted via WhatsApp",
      "note-deleted": "Note deleted!",
      "note-info": "Notes are saved in the activity tab in the candidate details. You can edit or delete the note afterwards.",
      "nxtform-journey": "NxtForm Journey",
      "official-address": "Official address",
      "on-pension": "On retirement?",
      "open-resume": "Open CV",
      "open-video-call": "Join videocall meeting",
      "parse-cv": "Parse resume | Parse resumes",
      "parse-resume": "Parse resume | Parse resumes",
      "parsed-data": "Data from parsed document",
      "partner-info": "Partner info",
      "partner-salary": "Partner Salary",
      "payment-details": "Payment details",
      "pension": "Pension",
      "phase": "Phase",
      "poke": "Poke | \nPoked",
      "poke-candidate": "Poke candidate",
      "pool": "Pool | Pools",
      "pools-candidate-has-been-deleted-from": "Pools from which the candidate was removed",
      "position-name": "The name of the job",
      "preferences": "Preference | \nPreferences",
      "preferred-functions": "Desired functions",
      "preferred-job-type": "Desired job type",
      "preferred-job-types": "Desired job type(s)",
      "profession": "Profession",
      "profile-picture": "Profile picture",
      "propose-candidate": "Proposals to firm",
      "referral-code": "referral code",
      "regions": "Working region | Working regions",
      "reset-poked": "Reset poke",
      "residential-address": "Residence address",
      "resume": "CV",
      "retired-since": "Retired since",
      "school": "School",
      "searched-functions": "Wanted functions",
      "select-customer": "Select customers",
      "send-form": "Send NxtForm Journey",
      "show-candidate-details": "Show details of the candidate",
      "social-security-number": "Social security number | \nBelgian RRNR",
      "statute": "Statute",
      "tax-certificate": "Tax certificate",
      "work-schedules": "Work schedule",
      "transport-methods": "Transport",
      "upload-curriculum-vitae": "Upload a resume",
      "upload-id-card": "Upload ID card",
      "upload-profile-picture": "Upload profile picture",
      "valid-from": "Valid from",
      "valid-till": "Valid till",
      "verify": "Request information from the candidate.\nThe candidate will see this as a to do in the app.",
      "verify-description": "You wish to verify the candidate's data.\n\n This will create a task in the candidate's app in which the data can be completed/verified.",
      "verify-title": "Verify data",
      "voluntary-amount": "Voluntary amount",
      "voluntary-percentage": "Voluntary percentage",
      "withholding-tax": "Withholding tax",
      "work-experience": "Experiences",
      "work-experience-types": "Type",
      "job-references": "Job reference | Job references",
      "add-to-pay": "Add as NxtPay employee",
      "eid": "eID",
      "drag-eid-here": "Drag the eID into this box",
      "eid-has-been-loaded": "eID data was taken over",
      "view-working-documents": "View working documents",
      "identity-documents": "Identity documents",
      "sex": "Gender",
      "identity-card-front": "Front of ID card",
      "identity-card-back": "Back of ID card",
      "work-permit": "Work permit",
      "birth-place": "Place of birth",
      "references": "Reference \nReferences",
      "bulk-parse-resume-warning": "A maximum of 20 files can be processed at a time.",
      "slots": "Slots",
      "employee": "Employee",
      "resume-upload": {
         "title": "Parse resumes in bulk V2",
         "subtitle": "Upload multiple CVs here. You don't have to wait for all CVs to be uploaded to start reviewing.",
         "subtitles": {
            "load": "Upload multiple CVs here. You don't have to wait for all CVs to be uploaded to start reviewing.",
            "review": "Review the uploaded CVs here for missing data or validate against similar candidates.",
            "validate": "Possible existing talent found. Select the right match or create a new talent.",
            "confirm": "Choose which talent you want to save and/or add to a call list."
         },
         "go-to": "Go to",
         "upload-placeholder": "Drag & drop or browse files",
         "supported-formats": "Supported formats: PDF, DOC, DOCX, ODT, JPG, PNG",
         "save-and-close": "Save & close (continue later)",
         "review-cvs": "Review CVs",
         "confirm-import": "Import candidates",
         "confirm-talents": "Confirm {count} talent | Confirm {count} talents",
         "confirm-success": "{created} new and {updated} updated candidates imported",
         "confirm-counts": "{new} new - {updated} updated",
         "selected-count": "{count} selected",
         "review-progress": "{done}/{total} reviewed",
         "validate-progress": "{done}/{total} validated",
         "mark-as-reviewed": "Mark as reviewed",
         "mark-as-to-review": "Mark as to review",
         "confirm-and-next": "Confirm and next",
         "bulk-review-success": "{count} CV marked as reviewed | {count} CVs marked as reviewed",
         "bulk-review-failed": "{count} CV requires attention | {count} CVs require attention",
         "no-docs-to-review": "No processed CVs to review yet.",
         "no-duplicates": "No duplicates to validate.",
         "select-cvs": "Select CVs",
         "select-doc": "Select a CV in the list.",
         "preview-unavailable": "No preview available for this file type.",
         "refined-detection": "Refined detection",
         "refined-detection-link": "Go to refined detection >",
         "refined-detection-done": "Done refining",
         "refined-detection-unavailable": "Refined detection is not available for this CV.",
         "found-in-cv": "Found in CV",
         "found-in-nxtpeople": "Found in NxtPeople",
         "new-talent": "New talent",
         "pending-docs-warning": "{count} CV still requires an action before you can import | {count} CVs still require an action before you can import",
         "processing-docs-warning": "Some CVs are still being processed. Please wait until they are ready before importing.",
         "link-source": "Link source to talent",
         "save-in-call-list": "Save talent in call list",
         "no-call-list-title": "No call list selected",
         "no-call-list-warning": "You did not select a call list. The candidates will be added to the default candidate list.",
         "import-anyway": "Import without call list",
         "doc-status": {
            "to-review": "To review",
            "reviewed": "Reviewed",
            "validate-duplicate": "Validate duplicate",
            "validated": "Validated",
            "completed": "Completed"
         },
         "tabs": {
            "load": "Load CVs",
            "review": "Review CVs",
            "validate": "Validate duplicates",
            "confirm": "Confirm"
         },
         "max-files-warning": "A maximum of {max} files can be processed at a time.",
         "files-rejected": "{count} file(s) were skipped (unsupported type or too large).",
         "upload-failed": "Upload failed",
         "batch-failed": "Could not start the upload",
         "status": {
            "pending": "Pending",
            "uploading": "Uploading..",
            "processing": "Processing..",
            "done": "Done",
            "failed": "Failed"
         }
      }
   },
   "communication": {
      "unread-filter": "Show only unread messages"
   },
   "communications": {
      "actions": {
         "scroll-to-load-messages": "Scroll to load messages"
      },
      "all-channels": "All channels",
      "all-directions": "All directions",
      "all-teams": "All teams",
      "change-team": "Change communication team",
      "channel": "Channel",
      "communication": "Communication | Communications",
      "conversation": "Message | Messages",
      "direction": "Direction",
      "end-of-messages": "End of messages",
      "go-to-mail-conversations": "Go to email conversation with {name}",
      "go-to-message-conversations": "Go to SMS/WhatsApp conversation with {name}",
      "incoming": "Incoming",
      "linked-customer": "Linked customer",
      "linked-position": "Linked vacancy",
      "mark-as-read": "Mark as read",
      "mark-as-unread": "Mark as unread",
      "outgoing": "Outgoing",
      "receiver": "Reciever",
      "search-for-candidate": "Search candidate",
      "search-for-customer": "Search customer",
      "search-on-email": "Search on email",
      "search-on-phonenumber": "Search phone number",
      "sender": "Sender",
      "show-most-recent-message": "Show most recent message",
      "type-a-message": "Type a message",
      "24-hours-after-last-send-message": "More than 24 hours have passed since the last incoming message.",
      "click-to-send-as-sms": "Click here to send as a text message.",
      "communication-has-been-send-as-type": "Your message was sent as {type}!",
      "recipients": "Recipient | Recipients",
      "bind_number": "Linking communications",
      "bind-number-modal": {
         "title": "Link communication to {type}"
      },
      "no-type-found": "No {type} found for phone number!",
      "want-to-create-a-new-type": "Would you like to create a new {type}?",
      "sms-character-limit": "SMS character limit: {limit} characters"
   },
   "customer": {
      "no-company-results": "No results were found. Enter a company number or name to import it!",
      "import-company": "Import",
      "note-info": "Notes are stored under the activities tab in the detail of the company. \nYou can change or delete it afterwards."
   },
   "customers": {
      "activity": "Activity | Activities",
      "add-activity": "Add activity",
      "add-customer": "Add customer",
      "address-deleted": "Address has been deleted!",
      "addresses": "Employment addresses | Employment addresses",
      "branch-amount": "Number of branches",
      "click-to-go-to-customer": "Click here to view the customer.",
      "closing-date": "Closing date",
      "commercial-name": "Commercial name",
      "company-data": "Company data",
      "company-number": "Company number",
      "contact-added": "Contact added",
      "contact-deleted": "Contact has been deleted!",
      "contacts": "Contact | Contacts | Contacts",
      "customer": "Customer | Customers",
      "customer-address": "Customer address",
      "customer-created": "Customer has been added",
      "customer-data": "Customer data",
      "customer-name": "Customer name",
      "customer-updated": "Customer has been updated",
      "creditworthiness-warning": "Warning: This customer has a negative creditworthiness status ({credit_worthy_status_name}).",
      "delete-customers": "Delete customer | Delete customers",
      "dutch-company-number": "KVK number",
      "dutch-vat-number": "company number",
      "edit-customer": "Customize customer",
      "email-missing": "E-mail is missing",
      "employee-amount": "Number of employees",
      "employment-address": "Employment address",
      "employment-region": "Employment region",
      "founded-at": "Founding date",
      "free-edit-text": "Mail to customer",
      "french-company-number": "Siren number",
      "french-vat-number": "Siren number",
      "interim-amount": "Number of interim workers",
      "legal-form": "Legal form",
      "mail-customers": "Mail customer | Mail customers",
      "max-amount-customers": "{amount} entreprises au maximum",
      "nace-code": "NACE code",
      "name": "Name",
      "official-name": "Official name",
      "phone-number-missing": "Phone number is missing",
      "primary-address": "Corporate headquarters | Corporate head-quarters",
      "sector": "Sector",
      "select-contact-person": "Select contact",
      "spontaneous-application-not-allowed": "Spontaneous applications to this company are not allowed.",
      "spontaneous-application-team-only": "Spontaneous applications to this company are only allowed for team {team}.",
      "spontaneous-application-access": "Spontaneous application",
      "vat-number": "Vat-number",
      "vat-number-error": "Invalid {item}!"
   },
   "follow-up": {
      "add-new-status": "Add new status",
      "assign-to": "Assign",
      "assigned-by": "Assigned by",
      "assigned-to": "Appointed to",
      "by": "By",
      "change-hit": "Modify match",
      "change-status": "Correct status",
      "click-here-to-view-match": "\nClick here to open the match",
      "completed": "completed",
      "create-task": "Create a task",
      "created-by": "made by",
      "delete-hits-description": "Are you sure you want to delete this match? \n| \nAre you sure you want to delete these matches?",
      "delete-match": "Delete match | \nDelete matches",
      "description": "Description",
      "expired-at": "Expires on",
      "follow-up": "Follow up | Follow ups",
      "form-follow-up": "NxtForm follow-up",
      "general": "General",
      "go-to-matching": "Start Matching!",
      "spontaneous-application-not-allowed": "Spontaneous applications to this company are not allowed.",
      "hit": "Match | Matches",
      "hit-changed": "Match is modified",
      "hit-closed": "Close Match | Close matches",
      "hit-created": "Match created | Matches created",
      "hit-deleted": "Match removed | \nMatches removed",
      "hit-filled": "Match filled",
      "hit-status-added": "Match status added",
      "hit-status-changed": "Match status changed | Matches statuses changed",
      "hits-afsluiten": "Close matches",
      "mark-as-completed": "Mark as completed",
      "mark-as-incomplete": "Mark as incomplete",
      "new-status": "Add next status",
      "select-application": "Select application",
      "show-completed-tasks": "Show completed tasks",
      "subject": "Subject",
      "subject-type": "Subject type",
      "task-type": "Task type",
      "tasks": "Task | \nTasks",
      "create-hit": "Create a match",
      "edit-task": "Adjust task",
      "assign-user": "Assign user to match",
      "attendance": "Attendance"
   },
   "general": {
      "no-mails-possible": "No mails possible for the selected values",
      "contact-person": "Contact"
   },
   "generic": {
      "access-denied": "No access",
      "account": "Account",
      "action-cant-be-undone": "This action cannot be undone, are you sure?",
      "actions": "Actions",
      "active": "Active",
      "add-contact": "Add contact",
      "add-phone-number": "Add phone number",
      "add-to-call-list": "Add to call list",
      "addresses": {
         "add-address": "Add address",
         "add-employment-address": "Add employment address",
         "address": "Address",
         "address-added": "Address has been added",
         "address-updated": "Address updated",
         "box": "Box",
         "city": "City",
         "country": "Country",
         "number": "Number",
         "postal-code": "Postal Code",
         "street": "Street",
         "update-address": "Edit employment address",
         "use-location": "Use location to get better results"
      },
      "again": "Again",
      "all": "All",
      "alternative-labels": "Alternative labels",
      "anonymous": "Anonymously",
      "answer": "Answer",
      "app-update-status": "Cool new features on the way... Therefore, downtime may occur on Thursday between 6pm and midnight. Thank you for your patience during the maintenance. Check the new features later!",
      "application": "Application",
      "appointment-created": "Appointment <b>{type}</b> with <b>{name}</b> on <b>{date}</b> has been scheduled.",
      "back-to-home-screen": "To home-screen",
      "based-on-adres": "based on address",
      "body": "Content",
      "call": "Dial",
      "call-later": "Call back later",
      "call-registerd": "Call is registered",
      "can-edit": "Can customize",
      "change-callList": "Change call list",
      "change-filters": "Edit search query",
      "direct-search-priority-info": "Your filters remain active during a direct search.",
      "characters-left": "{count} characters left",
      "choose-year": "Enter a specific year",
      "clear": "Empty",
      "clear-cache": "Clear cache",
      "cache-cleared": "Cache cleared",
      "click-here-to-view-the-message": "Click here to view the message",
      "comment": "Remark",
      "communication": "Communication | Communi-cation",
      "communication-created": "Communication is registered",
      "communication-language": "Communication language",
      "communication-via": "Communication via",
      "confirm-remove-filter": "Delete search query {name}. This action cannot be undone, are you sure?",
      "confirmation-text": "Confirmation text",
      "contact": "Contact",
      "contact-added": "Contact has been added",
      "contact-data": "Contact details | Contact details",
      "contact-updated": "Contact has been updated",
      "content": "Content",
      "continue-editing": "Continue editing",
      "continue-editing-form": "Complete the form",
      "copied-to-clipboard": "{type} copied!",
      "created-at": "Created at",
      "customer": "Customer | Customers",
      "dates": {
         "date": "Date",
         "day": "Day | \nDays | \nd",
         "days": {
            "friday": "Fri | Friday",
            "monday": "Mon | Monday",
            "saturday": "Sat | Saturday",
            "sunday": "So | Sunday",
            "thursday": "Thu | Thursday",
            "tuesday": "Tue | Tuesday",
            "wednesday": "Wed | Wednesday"
         },
         "end-date": "End date",
         "from": "From",
         "hour": "Hour | Hours | h",
         "month": "Month | Months | m",
         "present": "Present",
         "start-date": "Start date",
         "till": "Until",
         "week": "week | \nWeeks | \nw",
         "year": "Year | Years | j"
      },
      "delete": "{name} has been deleted!",
      "delete-file": "Are you sure you want to delete this {fileType}?",
      "delete-resume": "Are you sure you want to delete the CV?",
      "deleted-successfully": "{type} has been deleted!",
      "description": "Description",
      "deselect-all": "Deselect all",
      "diff": "Employment period",
      "direct-search": "Direct search",
      "document": "File | Files",
      "document-type": "Document type",
      "documents": "Document | Documents",
      "dont-save": "Don't save",
      "drag-file-to-upload": "Drag and drop a file to upload",
      "drop-file-here": "Drop your file(s) here!",
      "duration": "Period",
      "edit": "Edit | \n{name} modified!",
      "edit-call-list": "Customize call list",
      "edit-filters": "Customize search",
      "email": "E-mail",
      "event": "Event",
      "email-send-success": "Email(s) have been sent.",
      "employer": "Employer",
      "end": "End",
      "erase-filters": "Clear filters",
      "reset-filters": "Reset filters",
      "expire-date": "Expire date",
      "expires-in": "Expires in",
      "expires-on": "Expires on:",
      "fax": "Fax machine",
      "feedback": {
         "candidate-selection": "Enter a customer (and optionally vacancy) to display proposition options in the contact flow.",
         "communication-preference-warning-description": "This candidate does not wish to be contacted by phone, are you sure you want to call?",
         "communication-saved": "Communication finished",
         "customer-selection": "Enter a candidate (and optionally vacancy) to display proposition options in the contact flow.",
         "date-cannot-be-after": "Date cannot be after {date}!",
         "date-cannot-be-before": "Date cannot be before {date}!",
         "down-for-maintenance": "Sorry, we're down for scheduled maintenance right now!",
         "duplicate-file": "Duplicate file",
         "error": "Something went wrong!",
         "failed-sms": "{amount} text messages could not be sent.",
         "failed-whatsapp": "{amount} WhatsApp messages could not be sent.",
         "file-too-large": "The file you are trying to upload is too large!",
         "invalid-email": "This is not a valid email address",
         "invalid-url": "This is not a valid url",
         "invited-for-videocall": "Video calling invitation has been sent",
         "is_qualified": "Eligible",
         "loading": "Loading...",
         "max-filesize": "The maximum allowed filesize is {amount}{sizeType}.",
         "max-length": "The maximum length is {value}",
         "max-options": "Maximum {amount} {type}",
         "max-value": "The maximum value is {value}",
         "min-length": "The minimum length is {value}",
         "min-value": "The minimum value is {value}",
         "no-access": "No access to the requested data",
         "no-recipient-with-permission": "Recipient does not wish to be contacted via {methode}.",
         "no-results": "No result | No results",
         "no-valid-language": "Select a valid language",
         "no-valid-recipient": "Please select a valid recipient",
         "no-valid-recipients": "Recipients do not wish to be contacted via {methode}.",
         "no-valid-template": "Template: \"<strong>{templateKey}</strong>\" could not be found. Check the template settings in Mandrill.",
         "no-valid-template-translation": "Template does not exist in this language ({lang})!",
         "not-qualified": "Not eligible",
         "position-selection": "Enter a candidate to display proposition options in the contact flow.",
         "refresh-to-update": "An update is available. \nRefresh the page to install the update.",
         "required": "This field is required",
         "service-unavailable": "Service unavailable!",
         "start-typing-to-search": "Start typing to search...",
         "sucessful-change-communication": "{amount} communication messages were modified",
         "sucessful-sms": "SMS(es) have been sent.",
         "sucessful-whatsapp": "WhatsApp messages sent",
         "unsaved-changes": "Don't save changes?",
         "unsaved-changes-description": "If you click “delete”, all changes made will be lost. Click “Cancel” to continue editing",
         "update-available": "An update is available.",
         "whatsapp-sent": "WhatsApp message sent",
         "contact-support": "Please contact our support service if the problem persists",
         "not-allowed": "You have no quantity to the requested data",
         "not-found": "We could not find the requested data.",
         "validation": "Wrong during the validation of the data",
         "file-type-not-allowed": "File type is not allowed!"
      },
      "file-delete-failed": "Something went wrong! The file has not been deleted!",
      "file-exists": "A document of type {type} already exists. If you continue, the document will be replaced.",
      "file-name": "File name",
      "filter-changed": "Search query has been modified",
      "filter-created": "Search query has been added",
      "filter-important": "Mark filter as important",
      "filter-info": "Combine keywords with:<br>\n<strong>OR</strong>: one of the keywords must appear in the result.<br>\n<strong>AND</strong>: both keywords must appear in the result.<br>\n<strong>NOT</strong>: the keyword must not appear in the result.<br>\n<strong>?</strong>: to take into account multiple spellings. e.g.: \"Colo?r\"<br>\n<strong>\"\"</strong>: to search for the exact keyword or 2 words together. e.g.: \"The Sun\"<br>",
      "filter-less-important": "Mark filter as less important",
      "filter-removed": "Search query has been deleted",
      "filters": "Search | \nSearches",
      "fiscal-data": "Fiscal data",
      "form": {
         "next": "Next",
         "previous": "Previous",
         "select": "Select | Select {type}",
         "missing-data": "Missing data: Complete {properties}."
      },
      "free-text": "Free text",
      "function-category": "Function category",
      "function-data": "Function data",
      "general": "General",
      "general-data": "General data",
      "give-call-list-a-name": "Give your call list a name",
      "give-filter-a-name": "Give your search query a name",
      "global-videocall-url": "Video call platform url",
      "global-videocall-url-info": "Enter the url that takes users to the video call platform. This will be visualised in the contact form. The urls for the different rooms can be set for each team using the list below.",
      "how-do-you-wish-to-mail": "How do you wish to mail?",
      "how-do-you-wish-to-send": "How would you like to send?",
      "id": "Id",
      "id-card": "Identity card",
      "identity": "Identity",
      "important": "Important",
      "inactive": "Inactive",
      "in-office": "At the office",
      "include_job_distances": "Including work region",
      "included": "Included | {type} included",
      "incoming-call-from": "Incoming call from <b>{name}</b>",
      "interested": "Interested",
      "internal-comment-with-appointment": "Internal note on appointment",
      "internal-information": "internal information",
      "is-graduated": "Successful",
      "job-distances-included": "",
      "all-functions": "All functions",
      "job-functions": "Job function",
      "languages": "Language | Languages",
      "last-editted": "Last modified",
      "leave-page": "Are you sure you want to leave the page?",
      "leave-page-description": "When you leave the page, all changes will be deleted. Are you sure you want to leave the page?",
      "less-important": "Less important",
      "loading-items": "Loading {results} of {resultTotal} results",
      "location": "Location",
      "mail": "Email",
      "mail-editors": {
         "mail-candidate-to-customer": "Mail candidate to customer",
         "mail-candidate-to-team": "Mail candidate to team",
         "mail-positions-to-candidates": "Mail vacancies to candidates"
      },
      "mail-to": "Mail to",
      "match": "Match",
      "max": "Max | Maximum",
      "min": "Min | Minimum",
      "must-meet-all-parameters": "Must meet all parameters.",
      "must-meet-one-parameter": "Must meet one of the parameters.",
      "my-contact-data": "My contact details",
      "my-filters": "My search query's",
      "name": "Name | Names",
      "no": "No",
      "no-delete-permission": "No permissions to delete",
      "no-journey-selected": "Please select a Journey to continue!",
      "no-results-for-tenant": "No {type} were found for this search!",
      "no-roles-assigned": "No {module} rights have been assigned to your account. Contact an administrator to obtain the necessary permissions.",
      "no-url-provided": "No url provided, close the modal and try again!",
      "no-voip-found": "No VOIP found for current user",
      "none": "None",
      "not-passed": "Not succeeded",
      "note": "Note",
      "notification": "Notification | Notifications",
      "off": "Off",
      "office": "Office",
      "on": "On",
      "one": "any",
      "only-this-hit": "Only this match",
      "open-mail-editor": "Open Mail Editor",
      "optional": "Optional",
      "organisation": "Organization",
      "other": "Other",
      "passed": "Successful",
      "per": "Per",
      "personal": "Personal",
      "phone": "Call | Dial",
      "phone-number-invalid": "Entered value is not a valid phone number!",
      "phone-number-invalid-country": "Selected country is invalid!",
      "phone-number-nan": "Phone number is not a number!",
      "phone-number-primary": "Phone number (primary)",
      "phone-number-too-long": "Phone number is too long!",
      "phone-number-too-short": "Phone number is too short!",
      "phone-numbers": "Phone number | Phone numbers",
      "phone-numbers-primary": "Phone number (primary)",
      "plan-appointment": "Schedule appointment",
      "preview": "Example",
      "profile": "Profile",
      "profile-of-candidate-is-empty": "Profile data from this candidate is empty",
      "progressing": "In progress",
      "propose-candidate-to-customer": "presentation candidate to customer",
      "propose-position": "Present vacancy",
      "propose-to-customer": "Present to customer",
      "propose-to-description": "After validation, a match with status <strong>'{proposeTo}'</strong> will be created.<br>Note why this candidate is suitable for this vacancy.",
      "propose-to-team": "Present to team",
      "propose-to-team-description": "After validation, a match with status <b>Presentation candidate to team</b> will be created for the vacancy's team.",
      "propose-to-team-description-no-position": "After validation, a match with status <b>Presentation candidate to team</b> will be created for the responsible team.",
      "proposition": "proposition",
      "proposition-created": "<b>{name}</b> with status <b>{status}</b> has been added.",
      "publish": "Publish",
      "put-in": "Enter",
      "query-to-clipboard": "Search query copied",
      "question": "Question",
      "radius": "Radius",
      "reason": "Reason",
      "reference": "Reference",
      "refresh-results": "Refresh results",
      "registration": "Registration",
      "reminder-created": "{type} <b>Call back</b> with <b>{name}</b> on <b>{date}</b> has been scheduled.",
      "remove-callList": "Delete call list",
      "remove-filters": "Delete search query",
      "remove-selected-filters": "Remove selected filter(s).",
      "removed-selected-filters": "{amount} selected filter(s) have been removed",
      "restore-deleted-filters": "Reset selected filter(s).",
      "restored-deleted-filters": "{amount} selected filter(s) were reset",
      "results": "Result | Results",
      "resume-type": "Resume Type",
      "salutation": "Salutation",
      "save-call-list": "Save call list",
      "save-callList": "Save call list",
      "save-filters": "Save search query",
      "saved-searches": "Saved search queries",
      "scheduled-at": "Scheduled at",
      "score": "Score",
      "select-all": "Select all",
      "select-date-and-time": "Choose a date and time",
      "select-position": "Choose a vacancy",
      "select-videocall-room": "Select a video call room",
      "selected": "Selected",
      "send": "Send | Send",
      "send-appointment-via": "Send appointment via",
      "send-blind-copy": "Send BCC",
      "send-copy": "Send CC",
      "send-NxtJourney": "Send NxtForm journey",
      "send-resume-via": "Send resume type",
      "send-sms": "Send SMS | Send SMS",
      "send-videocall-invite": "Invite to video call",
      "send-whatsapp": "Send WhatsApp message",
      "share-call-list": "Share your call list",
      "share-filters": "Share your search query",
      "shared-with-me": "Shared with me",
      "show-less-filters": "Show less filters",
      "show-more": "Show more",
      "show-more-filters": "Show more filters",
      "size": "File size",
      "sms": "Text message",
      "sms-content": "Content SMS",
      "sms-sent": "SMS has been sent | SMS have been sent",
      "something-went-wrong": "Something went wrong",
      "something-went-wrong-description": "Something went wrong while retrieving essential data. To return to the home screen, click on the link below. If the problem persists, contact your system administrator.",
      "specific-unit-videocall": "Specific unit video call rooms",
      "spontaneous-propose-candidate-to-customer": "Present spontaneous to customer",
      "spontaneous-propose-to-customer": "Present spontaneous to customer",
      "status": "Status",
      "subject": "Topic",
      "template": "Template",
      "template-does-not-support-language": "Template doesn't support this language.",
      "this-action-cannot-be-undone": "This action cannot be undone.",
      "title": "Title",
      "to": "To",
      "transport": "Transport",
      "type": "Type | Types",
      "u-have-no-access": "No permission to view this page",
      "updated-at": "Updated at",
      "upload-date": "Upload date",
      "url-copied": "URL copied",
      "validate": "Validate",
      "variables": "Variables",
      "verification-requested": "Verification request has already been sent to the candidate",
      "verified-on": "Verified on: {dateTime}",
      "verify": "Verify",
      "verify-again": "Verify data again",
      "via": "Via",
      "videocall": "Video call",
      "videocall-change": "Customize video call",
      "videocall-meeting": "Videocall meeting",
      "videocall-room": "Video call room | \nVideo call rooms",
      "videocall-room-added": "Video call room added!",
      "videocall-room-changed": "Video call room has been updated!",
      "videocall-room-removed": "Video call room has been removed!",
      "website": "Website",
      "what-do-you-want-to-send": "What do you want to send?",
      "whatsapp": "whatsapp",
      "whereby-embedded-not-available": "Whereby is not available for: {type}!",
      "whereby-room": "Whereby room",
      "work-situation": "Working situation",
      "yes": "Yes",
      "closest-team-option": "Closest team",
      "kilometer": "Kilometer | km",
      "saved-search": "Saved search",
      "account-not-found-description": "We couldn't find your account in this module",
      "exception": "Exception | Exceptions",
      "limit": "Limit | Limits",
      "no-document-found": "No document found",
      "pin-activity": "Pin",
      "unpin-activity": "unpin",
      "global": "Global",
      "unlimited": "Unlimited",
      "publication-data": "Publication data",
      "extra": "Extra",
      "show-result": "Show result",
      "warning": "Note!",
      "nxt-jobs": "NxTjobs",
      "last-update": "Last updated",
      "relevance": "Relevance",
      "take-offline-action": "Take offline",
      "take-offline-notification": "Put offline request sent",
      "take-offline-not-allowed": "You have no permission to put the vacancy offline",
      "modify-status-action": "Modify status",
      "modify-status-notification": "Status modified",
      "modify-status-not-allowed": "You have no permission to modify the vacancy",
      "recently-graduated": "Recently graduated",
      "recently-graduated-description": "Candidate has finished an education in the last 3 months",
      "communication-preferences": "Communication preferences",
      "update-action": "Update action"
   },
   "matching": {
      "match": "Match | Matching",
      "select-source": "Choose a {sourceType}",
      "source-type": "Source",
      "switch-target-source": "Switch source and target",
      "target-type": "Target",
      "show-type-details": "Show {type} details"
   },
   "positions": {
      "activity": "Activity | Activities",
      "accepted-answer": "Desired answer",
      "add-position": "Add vacancy",
      "add-referral-code": "Add a referral code",
      "advertsdata": "Google vacancies",
      "application-url": "Application-url",
      "apply": "Apply",
      "apply-via": "Apply via",
      "auto-repost": "Auto-repost",
      "available-languages": "Available languages",
      "can-be-visible-in-app": "Display in app",
      "can-take-up-to-a-minute": "Generating text! \n| \nDon't worry, we'll be done before you know it! \n| \nWe're almost done, so hang in there!",
      "chatGPT": {
         "almost-done": "We're almost done, so keep the faith!",
         "busy-generating-text": "Generating text",
         "dont-worry": "Don't worry, we'll be done before you know it!"
      },
      "click-to-go-to-match": "Show match",
      "click-to-go-to-position": "Click here to go to the vacancy",
      "comma-separated": "comma separated",
      "copy-position": "Copy vacancy",
      "create-in-nxtmatch": "Create in NxtMatch",
      "date-of-creation": "Creation date",
      "delete-positions": "Delete vacancy | Delete vacancies",
      "edit-position": "Edit vacancy",
      "edit-website-status": "Modify website publication",
      "form-disabled": "Not available for external vacancies",
      "function-level": "Function level",
      "function-title": "Function title",
      "generate": "Generate",
      "generate-automatic-text": "Generate automatic text",
      "generate-automatic-text-info": "Based on the entered job title, an appropriate job vacancy text will be generated in the chosen language. Check this text and adjust it to match the agreed conditions.",
      "generation-error": "Cannot generate text for the entered function title!",
      "gross-wage": "Gross salary",
      "internal-contact": "Internal contact person | Internal contact person",
      "job-type": "Job type",
      "job-types": "Job type",
      "journey-referral": "Journey referral",
      "journey-referral-code-not-found": "Journey referral code \"nxt-match\" cannot be found!",
      "keywords": "Keywords",
      "knockout-questions": "Knockout question | Knockout questions",
      "location-search-info": "Search by company address. This may differ from the employment address in the vacancy.",
      "mail-position": "Suggest job vacancy(s)",
      "matches": "Matches",
      "max-10-positions": "Maximum 10 vacancies",
      "modify-status": "Are you sure you want to modify the status?",
      "no-delete-position-permission": "No permissions to delete this vacancy",
      "no-published-position-selected": "No published job selected",
      "not-visible-in-app": "Vacancy is not visible in app",
      "number-of-persons-wanted": "Number of persons wanted",
      "online": "Online vacancies",
      "only-open-position-published": "Only open vacancies can be published.",
      "open-position": "Open NxtMatch vacancy",
      "people-needed": "Number of candidates still sought",
      "please-choose-customer": "First choose a customer",
      "position": "Vacancy | Vacancies",
      "position-closed": "Vacancy is already closed",
      "position-created": "Vacancy has been added",
      "position-edited-and-online": "Position is published but has been changed!",
      "position-offline": "Vacancy is not published",
      "position-publish-failed": "Vacancy {title} was not put online due to an error",
      "position-published-edit-disabled": "Vacancy is published and cannot be edited",
      "position-put-offline": "Vacancy {title} was put offline",
      "position-put-online": " Vacancy {title} was put online",
      "position-taken-offline": "By modifying, the publication will be taken offline.",
      "position-updated": "Vacancy has been updated",
      "processing": "Process...",
      "publication": "Publication | Publications",
      "publication-data": "Publication data",
      "creation-date": "Creation date",
      "publication-date": "Publication date",
      "publication-sites": "Publication Website | \nPublication Websites",
      "nxtjob-sites": "NxtJob website | NxtJob websites",
      "publications": {
         "no-results": "No publications found!"
      },
      "put-offline": "Offline",
      "put-online": "Online",
      "referral-code-doesnt-match-with-nxt-match": "NxtMatch referral code cannot be found or does not match team.",
      "refresh-journey": "Refresh journey",
      "remove-language-confirmation-message": "Are you sure you want to remove this language? This action cannot be undone!",
      "remove-language-confirmation-title": "Are you sure you want to remove this language?",
      "translate-source-badge": "Source",
      "set-as-source": "Set {language} as source language",
      "set-as-source-info": "{language} becomes the new source for translations",
      "translate-from-source": "Translate from {source} to {target}",
      "translate-from-source-info": "Overwrites all {target} content",
      "translate-source-to-all": "Translate source to all languages",
      "translated-language": "{language} was automatically translated",
      "translate-overwrite-title": "Translate from {source}",
      "translate-overwrite-message": "Existing content will be overwritten by the automatic translation.",
      "translation-error": "Translation failed. Please try again later.",
      "switch-source-warning": "Switching the source language may overwrite existing content when translating.",
      "remove-language": "Remove {language}",
      "remove-language-info": "All content for {language} will be cleared",
      "required-attributes-missing": "Please fill in {attributes}",
      "startup-date": "Startup date",
      "summary-description-info": "This content is used as introduction text in the app and on job boards that support it.",
      "title": "Vacancy title",
      "user-spoc": "SPOC",
      "visible-in-app": "Vacancy is visible in app",
      "wage": "Wage",
      "wage-max": "Gross wage maximum",
      "wage-min": "Gross wage minimum",
      "wage-type": "Gross salary type",
      "wage-view": "Display gross salary",
      "wage-view-on-website": "Display of gross salary on website",
      "website-status": "Publication status",
      "website_url": "Website url",
      "young-talent": "Young talent",
      "hours-per-week": "Hours per week",
      "visible-in-nxt-job": "Show in Nxtjob",
      "external-publication": {
         "external-publication": "External publication",
         "failed-to-load": "Recruitment Technologies could not be loaded"
      },
      "recruit-anywhere": {
         "recruit-anywhere": "RecruitAnywhere"
      },
      "internal-publication": {
         "internal-publication": "Internal publication",
         "nxt-job-board": "NxtJob board | NxtJob boards",
         "show-in-app": "Show in app",
         "show-in-nxt-job": "Show in Nxtjob"
      },
      "tile-image": "Vacancy image",
      "position_does_not_belong_to_default_team": "Position does not belong to default team"
   },
   "reporting": {
      "reporting": "Reporting"
   },
   "settings": {
      "add-automatic-message": "Add automatic message",
      "add-target-group": "Add target group",
      "application-settings": "Application settings",
      "applied-default-filters": "Default filters applied for {name}",
      "applied-target-group-filters": "Applied audiences for {name}",
       "automatic-message-delete": "Delete automatic message?",
       "automatic-message-deactivated-at": "Automatically deactivated on {date}",
       "automatic-message-deactivation-inactive_journey": "The linked journey is inactive",
       "automatic-message-deactivation-limit_reached": "The message limit was reached",
       "automatic-messages": "Automatic message | Automatic messages",
      "available-filters": "Available filters",
      "available-target-groups": "Available Audiences",
      "data": "Data",
      "default-filters": "Default filters",
      "developer": "Developer",
      "filter-on-priority": "Filter by priority",
      "has-custom-settings": "Contains different settings",
      "is-mandatory": "Mandatory to apply?",
      "mandrill-template": "Mandrill template",
      "name-target-group": "Audience name",
      "no-filters-selected": "No default filters have been added for this team group yet. \nClick on one or more available filters in the list and add them with the orange button.",
      "no-target-group-filters-selected": "No target groups have been added yet. Click on one or more available target groups in the list to add them.",
      "no-target-groups-for-target-type": "No audiences have been added yet for this audience type.",
      "priority": "Priority | \nPriorities",
      "push-default-filters-to-teams": "This cluster contains one or more teams that contain deviating standard filters. \n{click} to apply the cluster settings in these teams.",
      "push-target-group-filters-to-teams": "This cluster contains one or more teams that contain different target groups. \n{click} to apply the cluster settings in these teams.",
      "remove-from-list": "Remove from list",
      "reset-team-default-filter-settings": "This team contains different default filters according to the parent cluster. \n{click} to restore the cluster's default filters.",
      "reset-team-target-group-filter-settings": "This team contains different target groups according to the parent cluster. \n{click} to take back the target groups of the cluster.",
      "saved-cluster-settings": "Cluster settings saved",
      "saved-team-settings": "Team settings saved",
      "settings": "Setting | Settings",
      "settings-for": "Settings for {name}",
      "target-group": "Target group | Target groups",
      "target-group-filter-edited": "Target group has changed",
      "target-group-filter-saved": "Target group has been created",
      "target-type": "Target type",
      "teams-without-cluster": "Teams without a team group",
      "unlock-team-default-filter-settings": "The parent cluster's default filters are applied. \n{click} to activate deviating default filters for this team.",
      "unlock-team-settings": "The settings of the parent cluster are applied. {click} to activate deviating settings for this team.",
      "unlock-team-target-group-filter-settings": "The target groups of the parent cluster are applied. \n{click} to activate different target groups for this team.",
      "zoom": "Zoom in",
      "cache-settings": "Cache data",
      "incoming-messages": "Incoming messages",
      "responsible-team-for-incoming-messages": "Responsible team for messages from unknown numbers",
      "automatic-message-limit": "Automatic messages limit",
      "automatic-message-has-limit": "Has a limit",
      "max-communications-per-user": "Outgoing communication limits per week",
      "max-sms": "SMS limit",
      "max-whatsapp": "WhatsApp limit",
      "max-email": "Email limit",
      "communication-exception-must-have-limits": "Exception must have a set limit!",
      "communication-exception-must-have-limits-description": "Enter one of the limits, SMS, WhatsApp or email to save it.",
      "amount-messages-sent": "{amount} messages sent",
      "empty-user-limit": "Please set at least a limit or delete the selected item.",
      "job-board-url": "URL",
      "job-board-name": "Name NxtJob page",
      "show-details": "Show Details",
      "hide-details": "Hide details",
      "interface-scale": "Interface size",
      "intro-text": "Leisure",
      "header-background-color": "Background color header",
      "header-font-color": "Text color header",
      "position-card-color": "Background color vacancy tile",
      "text-color": "Text color vacancy tile",
      "header-image": "Image Header",
      "logo-image": "Logo",
      "vdab": "VDAB",
      "notification-email": "Notification email address for deletion requests",
      "merger": "Candidate merger",
      "last-updated": "Last updated",
      "initial_candidate": "Initial candidate",
      "duplicate_candidate": "Duplicate candidate",
      "initial-candidate": "Initial candidate",
      "duplicate-candidate": "Duplicate candidate",
      "merge": "Merge",
      "only-deleted-searches": "Show only deleted searches"
   },
   "tasks": {
      "assign-user": "Assign user to task",
      "click-to-go-to-task": "Go to task",
      "remove-assigned-user": "Remove assigned user"
   },
   "teams": {
      "employer": "Employer | Employers",
      "no-team-email": "This team does not have an email!",
      "no-teams-selected": "No team(s) selected yet",
      "team": "Team | Teams",
      "team-address": "Team address",
      "team-name": "Team name"
   },
   "user-info": {
      "internal-job-function": "Function",
      "log-out": "Sign out",
      "user-settings": "User settings",
      "voip": "VoIP"
   },
   "users": {
      "no-users-selected": "No user(s) selected yet",
      "user": "User | Users"
   },
   "error": {
      "user_no_country_set": "User's team has no country!",
      "user_no_country_set_message": "Please contact an administrator!"
   },
   "errors": {
      "error": "Error | Errors",
      "account-not-found": "This account is unknown."
   }
}
